import React, { useState } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Button } from "../../ui-library/Button/Button";
import { Checkbox } from "../../ui-library/Checkbox/Checkbox";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "../../ui-library/Dialog";

import markdownStyles from "../../ui-library/MarkdownContent.module.css";

export interface TermsAndConditionsModalProps {
  open: boolean;
  onAccept: () => void;
  onClose: () => void;
  loading: boolean;
  termsContent: string | null;
  isLoadingTerms: boolean;
  error: string | null;
}

export const TermsAndConditionsModal: React.FC<
  TermsAndConditionsModalProps
> = ({
  open,
  onAccept,
  onClose,
  loading,
  termsContent,
  isLoadingTerms,
  error,
}) => {
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);

  return (
    <Dialog open={open} onClose={onClose} size="medium">
      <DialogHeader title="Terms and Conditions" />
      <DialogContent>
        {error ? (
          <>
            <p>{error}</p>
            <Button
              onClick={() => {
                window.location.reload();
              }}
            >
              Reload this page
            </Button>
          </>
        ) : isLoadingTerms ? (
          <p>Loading terms and conditions...</p>
        ) : (
          <div className={markdownStyles.MarkdownContent}>
            <Markdown remarkPlugins={[remarkGfm]}>{termsContent}</Markdown>
          </div>
        )}
      </DialogContent>
      <Checkbox checked={hasAcceptedTerms} onChange={setHasAcceptedTerms}>
        I've read and accepted the terms and conditions.
      </Checkbox>
      <DialogFooter>
        <Button
          onClick={onAccept}
          disabled={loading || !hasAcceptedTerms}
          aria-label="Continue"
        >
          {loading ? "Accepting..." : "Continue"}
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
